import { getCurrentProvider } from './manageSessionStorageData'
import routeAccessDescription from '../../config/routeAccessDescription'
import {
    GENERAL_LOGIN_PATH,
    MEMSOURCE_JOBS_LIST_PATH,
    TEMPO_DASHBOARD_PATH,
    XTRF_PROJECTS_LIST_PATH,
} from '../../config/pathList'
import { matchPath } from 'react-router-dom'
import { sameValueStringOrArray } from './comparators'
import { isAccessible } from './rolesAndPermissions'
import { Providers } from '../../interfaces/Providers'

export const isAccessAllowed = (location: string): boolean => {
    const provider = getCurrentProvider()
    const { type, permission } = routeAccessDescription.find((nav) =>
        matchPath(location, { path: nav.path, exact: true }),
    ) || { type: null, permission: null }
    return (
        type &&
        (type.length === 0 || sameValueStringOrArray(type, provider)) &&
        (!permission || isAccessible(permission))
    )
}

export const determineRedirection = () => {
    switch (getCurrentProvider()) {
        case Providers.memsource:
            return MEMSOURCE_JOBS_LIST_PATH
        case Providers.xtrf:
            return XTRF_PROJECTS_LIST_PATH
        case Providers.tempo:
            return TEMPO_DASHBOARD_PATH
        default:
            return GENERAL_LOGIN_PATH
    }
}
